import React from 'react';

import AppImage from '../../../../components/app-image/app-image';
import { lokalisation } from '../../../../helpers/lokalisation';
import { GuideStyled } from './guide.styled';

export const Guide = () => {
    const { a11yText } = lokalisation();

    return (
        <GuideStyled>
            <AppImage imageType={'img'} iconType={'guide'} alt={a11yText.guide} />
        </GuideStyled>
    );
};
